<template>
    <div class="card border-light rounded-3 shadow-lg">
        <div class="card-body">
            <h2 class="card-title h4 mb-4 text-primary">Renseigner ou modifier votre numéro de mobile</h2>
            <div v-if="!getUser.tel_mobile" class="alert alert-warning">
                Dans le cadre du renforcement de notre politique de sécurité, <br>nous vous invitons à renseigner votre numéro de téléphone mobile afin de recevoir vos codes de connexion par SMS.
            </div>
            <form @submit.prevent="changeMobile">
                <div class="row gx-4">
                    <div class="mb-3 col-md-10">
                        <label for="new-mobile">Mon numéro de téléphone mobile</label>
                        <IntlTelInput
                            initialCountry="fr"
                            :load-utils="() => import('intl-tel-input/utils')"
                            id="new-mobile"
                            v-model="mobile"
                            :required="!no_mobile"
                        />      
                        <!-- <input
                            type="tel"
                            id="new-mobile"
                            v-model="mobile"
                            class="form-control"
                            placeholder="Votre numéro de mobile"
                            :required="!no_mobile"
                            maxlength="10"
                            @input="mobile = mobile.replace(/\D/g, '').slice(0, 10)"
                        /> -->
                    </div>
                </div>

                <div class="row gx-4">
                    <div class="mb-3 col-md-10">
                        <label for="new-mobile-confirm">Confirmation du numéro de mobile</label>
                        <IntlTelInput
                            initialCountry="fr"
                            :load-utils="() => import('intl-tel-input/utils')"
                            id="new-mobile-confirm"
                            v-model="mobileConfirm"
                            :required="!no_mobile"
                        />  
                        <!-- <input
                            type="tel"
                            id="new-mobile-confirm"
                            v-model="mobileConfirm"
                            class="form-control"
                            placeholder="Votre numéro de mobile"
                            :required="!no_mobile"
                            maxlength="10"
                            @input="mobileConfirm = mobileConfirm.replace(/\D/g, '').slice(0, 10)"
                        /> -->
                    </div>
                </div>

                <label v-if="popup" class="checkbox-label mb-3">
                    <input
                    type="checkbox"
                    v-model="no_mobile"
                    @click="show_no_mobile_info"
                    />
                    Je n'ai pas de mobile ou je ne souhaite pas le communiquer
                </label>

                <div class="row gx-4">
                    <div class="col-md-10">
                        <div
                            :class="'alert' + (alert ? ' alert-' + alert.class : '') + ' text-center p-1 fs-n1' + (!alert ? ' d-none' : '')"
                            role="alert"
                            v-html="alert ? alert.message : '&nbsp;'"
                        ></div>
                    </div>
                </div>

                <button type="submit" class="btn btn-primary rounded-pill" :disabled="loading">Valider</button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IntlTelInput from "@intl-tel-input/vue";
import "intl-tel-input/styles";

export default {
    name: 'ChangeMobileForm',
    components: {
        IntlTelInput
    },
    data: () => ({
        mobile: '',
        mobileConfirm: '',
        no_mobile: false,
        loading: false,
        alert: null,
    }),
    props: {
        popup: Boolean
    },
    computed: {
        ...mapGetters(['getUser']),
        confirmMobile() {
            //* change when MEP code region tel
            if (!this.mobile || !this.mobileConfirm) return false
            return this.mobile === this.mobileConfirm

            // const digits = (this.mobile || '').replace(/\D/g, '')
            // const digitsConfirm = (this.mobileConfirm || '').replace(/\D/g, '')
            // return digits === digitsConfirm && digits.length === 10 && (digits.startsWith('06') || digits.startsWith('07'))
        },
    },
    methods: {
        ...mapActions(['updateMobile', 'confirmNewMobile', 'getProfile', 'showPopupMobile']),
        async changeMobile() {
            if (this.no_mobile) {
                const token = await this.updateMobile({mobile: 'no_mobile', no_mobile: true})
                const ok = await this.confirmNewMobile({ token: token.message })
                if (ok) await this.getProfile()
            } else if (!this.confirmMobile) {
                this.alert = { class: 'warning', message: 'Mauvaise confirmation du numéro de mobile' }
            } else {
                this.loading = true
                const digits = this.mobile || ''
                this.alert = await this.updateMobile({
                    mobile: digits,
                })
                this.loading = false
                if (this.alert && this.alert.class === 'success') {
                    // this.mobile = ''
                    // this.mobileConfirm = ''
                    setTimeout(() => {
                        this.showPopupMobile()
                        this.$router.push('/suivi')
                    }, 15000)
                }
            }
        },
        show_no_mobile_info() {
            if (!this.no_mobile) {
                this.alert = { class: 'primary', message: 'Votre choix a bien été pris en compte. Vous recevrez votre code de connexion par e-mail.<br>Vous pourrez toujours nous indiquer ultérieurement un numéro de mobile en cliquant sur « Gérer votre compte » puis « Renseigner ou modifier votre numéro de mobile. »<br>Vous allez être automatiquement redirigé(e) vers votre espace questionnaires dans quelques secondes.' }
            } else {
                this.alert = null
            }
        }
    },
}
</script>

<style scoped>
:deep(.iti) {
    width: 100%;
}

:deep(.iti__tel-input) {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}

:deep(.iti__tel-input:focus) {
    color: #212529;
    background-color: #fff;
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>